<template>
  <div class="about_container">
    <div class="first_page">
      <div class="title">
        <div class="top_title">
          飞视巡检
        </div>
        <div class="bottom_title">
          国内领先的城市级无人机巡检服务商
        </div>
      </div>
      <div class="first_discription">
        衢州东南飞视科技有限公司（以下简称“飞视”）成立于2020年8月4日，是浙江省衢州市委市政府”一号院”——东南数字经济发展研究院投资孵化的高科技企业，聚焦城市级无人机巡检，是国内领先的城市级无人机巡检服务商。先后入选浙江省科技型中小企业、浙江省创新型中小企业、浙江省专精特新中小企业、国家级高新技术企业、衢州市级工程技术研发中心，并入库智慧新城规上企业、入选衢州市上市培育名单。
        <p></p>
        自主研发飞视平台，通过系列先进AI算法，实现无人机场自主飞行、采集、分析和推送，算法覆盖70多种应用场景。创新研发高效低成本的三维底座算法fs3D、航线智能智能规划算法fsFLY、行业大模型fsX，以及语言交互fsGPT等核心技术，使无人机巡检的安全性、机动性、应用性得到飞跃式提升。
        <p></p>
        展望未来，飞视希望实现一城一网、一城一人、全城共用，真正推动基层治理现代化。同时，飞视将坚定不移地推进技术创新，力求为各行各业提供更为安全、实用、高效的无人机巡检体验。
      </div>
    </div>
    <div class="second_page">
      <div class="title">发展历程</div>
      <div class="progress">
        <div class="first_progress">
          <div class="line" v-for="item in progress[0]" :key="item.year">
            <div class="circle"></div>
            <div class="year">{{ item.year }}</div>
            <div class="event" v-html="item.event"></div>
          </div>
        </div>
        <div class="first_progress">
          <div class="line" v-for="(item,index) in progress[1]" :key="item.year">
            <div class="circle"></div>
            <div class="year">{{ item.year }}</div>
            <div class="event" v-html="item.event"></div>
            <svg-icon v-if="index == progress[1].length - 1" icon-class="arrow"></svg-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="third_page">
      <div class="title">
        荣誉资质
      </div>
      <div class="content">
        <ul class="left">
          <li v-for="(item,index) in honor" :key="index">{{ item }}</li>
        </ul>
        <!-- <img src="@/assets/images/about/honor.png"/> -->
      </div>
    </div>
    <div class="four_page">
      <!-- <img src="@/assets/images/about/map.png"/> -->
      <div class="img"></div>
      <div class="title">
        项目合作遍布多个省市
      </div>
      <div class="discription">
        <div>浙江、上海、江苏、广东、福建、湖北、安徽、湖南、江西、四川、重庆、广西、云南、广西、海南、山东、</div>
        <div>河北、陕西、山西、辽宁、黑龙江、新疆、内蒙古等</div>
      </div>
    </div>
    <div class="five_page">
      <div class="title">联系我们</div>
      <div class="content">
        <div class="left">
          <div class="contact">
            <div class="top">
              <svg-icon icon-class="phone"></svg-icon>
              业务合作
            </div>
            <div class="msg">
              手机：17769553399（微信同号）
              <div class="divide"></div>
              电话：0570-3358803，周一至周五（节假日除外）09:00-17:30
            </div>
          </div>
          <div class="address">
            <div class="top">
              <svg-icon icon-class="location"></svg-icon>
              公司地址
            </div>
            <div class="msg">
              浙江省衢州市柯城区芹江东路288号衢时代创新大厦16楼
            </div>
          </div>
        </div>
        <div class="map_address"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 发展历程
      progress: [
        [
          {
            year: '2020',
            event: '衢州东南飞视科技有限公司成立',
          },
          {
            year: '2021',
            event: '综合飞一次1.0系统平台发布<br/>获天使轮投资',
          },
          {
            year: '2022',
            event: '综合飞一次2.0系统平台上线<br/>评为国家级高新技术企业<br/>成立博士创新站',
          },
          {
            year: '2023',
            event: '获 Pre-A轮千万级融资<br/>成立杭州飞视、湖南森巡子公司',
          },
        ],
        [
          {
            year: '2024',
            event: '成立广东办事处<br/>飞视巡检3.0上线/小程序扫码下工单<br/>苏州飞视子公司成立',
          },
          {
            year: '2025',
            event: '国际化英文版工作台上线<br/>机场接入数量突破400台<br/>杭州飞视智巡第二家子公司成立',
          },
        ]
      ],
      // 荣誉
      honor: [
        '国家高新技术企业','浙江省专精特新中小企业','2024“数据要素X”大赛浙江分赛城市治理赛道二等奖','2023全国新型智慧城市建设“百佳创新案例”','2023年度长三角智慧城市(城市大脑)优秀案例','2023数字经济创新提质一号发展工程优秀案例',
        '2023年度城乡历史文化保护与传承示范案例','2023大综合一体化行政执法改革最佳实践案例','浙江省创新型中小企业','2022第五批数字司法好应用','浙江省科技型中小企业',
        '2021浙江省城市大脑(智慧城市)场景应用优秀案例','2021数字乡村最佳实践案例','智慧新城管委会2023年创新之星一等奖',
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
.about_container{
  .first_page{
    width: 100vw;
    height: 100vh;
    min-height: 780px;
    background-image: url('@/assets/images/about/background1.png');  
    background-size: cover;
    position: relative;
    .title{
      position: absolute;
      top: vh(148);
      left: 50%;
      transform: translateX(-50%);
      .top_title{
        font-weight: 500;
        font-size: 42px;
        color: #FFFFFF;
        text-align: center;
        line-height: 64px;
        margin-bottom: 8px;
      }
      .bottom_title{
        font-weight: 400;
        font-size: 18px;
        color: #FFFFFF;
        letter-spacing: 0.9px;
        text-align: center;
        line-height: 32px;
      }
    }
    .first_discription{
      width: vw(880);
      max-height: vh(400);
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: justify;
      line-height: 22px;
      text-shadow: 0 1px 4px #00000080;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: vh(60);
    }
  }
  .second_page{
    width: 100vw;
    height: 580px;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px;
    padding-top: 70px;
    .title{
      font-weight: 500;
      font-size: 32px;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      line-height: 48px;
      margin-bottom: 55px;
    }
    .progress{
      width: 100%;
      max-width: 1440px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .first_progress{
        width: 100%;
        max-width: 1440px;
        height: 128px;
        display: flex;
        margin-bottom: 62px;
        .line{
          width: 360px;
          height: 2px;
          margin-top: 40px;
          background: #000000;
          position: relative;
          .circle{
            position: absolute;
            width: 10px;
            height: 10px;
            background: #000000;
            border-radius: 50%;
            left: 0;
            top: -5px;
          }
          .year{
            font-weight: 500;
            font-size: 26px;
            color: #000000;
            letter-spacing: 0;
            line-height: 28px;
            bottom: 16px;
            position: absolute;
          }
          .event{
            font-weight: 400;
            font-size: 14px;
            color: #000000cc;
            letter-spacing: 0;
            line-height: 22px;
            position: absolute;
            top: 16px;
          }
          .svg-icon{
            position: absolute;
            right: -6px;
            top: -4px;
            width: 10px;
            height: 10px;
          }
        }
      }
    }
    @media (max-width: 1520px) {  
      .progress{
        .first_progress{
          .line{
            width: 25%;
          }
        }
      } 
    }  
  }
  .third_page{
    width: 100vw;
    height: 680px;
    // background-image: linear-gradient(179deg, #000000 2%, #191B1C 98%);
    background-image: url('@/assets/images/about/honor.png');  
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px;
    padding-top: vh(70);
    .title{
      font-weight: 500;
      font-size: 32px;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      line-height: 48px;
      margin-bottom: vh(40);
    }
    .content{
      width: calc(100vw - 80px);
      max-width: 1440px;
      height: 440px;
      display: flex;
      justify-content: space-between;
      .left{
        width: 458px;
        overflow-y: auto;
        overflow-x: hidden;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        padding-left: 18px;
        li{
          margin-bottom: 20px;
          &::marker{
            color:#E30000;
            width: 6px;
            height: 6px;
          }
        }
      }
      img{
        width: vw(740);
        height: vh(440);
      }
    }
    @media (max-width: 1520px) {
      .content{
        width: vw(1440);
      }
    }
  }
  @media (max-width: 1520px) {
    .third_page{
      display: block;
    }
  }
  .four_page{
    width: 100vw;
    height: 780px;
    background-image: url('@/assets/images/about/background2.png');  
    background-size: 100vw 780px;

    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: vh(70);
    .img{
      width: 738px;
      height: 557px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      background-image: url('@/assets/images/about/map.png');  
      background-size: contain;
      background-repeat: no-repeat;
      background-position: bottom center;
    }
    .title{
      font-weight: 500;
      font-size: 32px;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      line-height: 48px;
      margin-bottom: 16px;
    }
    .discription{
      width: 928px;
      height: 48px;
      font-weight: 400;
      font-size: 16px;
      color: #000000cc;
      letter-spacing: 0;
      text-align: center;
      line-height: 24px;
      padding: 0 70px;
    }
  }
  .five_page{
    width: 100vw;
    height: vh(560);
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px;
    padding-top: vh(70);
    .title{
      font-weight: 500;
      font-size: 32px;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      line-height: vw(48);
      margin-bottom: vw(54);
    }
    .content{
      width: calc(100vw - 80px);
      max-width: 1440px;
      height: vh(270);
      display: flex;
      justify-content: space-between;
      .left{
        padding-top: vh(36);
        .contact{
          margin-bottom: vh(48);
          .top{
            font-weight: 500;
            font-size: 18px;
            color: #333333;
            letter-spacing: 0;
            line-height: 20px;
            margin-bottom: 12px;
          }
          .divide{
            height: 8px;
          }
          .msg{
            font-weight: 400;
            font-size: 14px;
            color: #000000cc;
            letter-spacing: 0;
            line-height: 22px;
          }
        }
        .address{
          .top{
            font-weight: 500;
            font-size: 18px;
            color: #333333;
            letter-spacing: 0;
            line-height: 20px;
            margin-bottom: 12px;
          }
          .msg{
            font-weight: 400;
            font-size: 14px;
            color: #000000cc;
            letter-spacing: 0;
            line-height: 22px;
          }
        }
      }
      .map_address{
        width: vw(520);
        height: vh(270);
        background-image: url('@/assets/images/about/address.png');  
        background-size: contain;
        background-repeat: no-repeat;
        background-position: bottom center;
      }
    }
  }
  @media (max-width: 1520px) {
    .five_page{
      display: block;
      .content{
        // width: vw(1440);
      }
    }
  }
}

::-webkit-scrollbar {
  margin-top: 10px;
  width: 2px;
  height: 10px;
  background-color: rgb(255, 255, 255, 0.2);
}

// 滚动条的背景色
::-webkit-scrollbar-track {
  width: 2px;
  background-color: rgb(255, 255, 255, 0.2);
}

// 进度条中间的颜色
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: #EDEDED;
}
</style>